import { Claim, Payment } from 'domains/billing';
import { Diagnosis, MedicalDiagnosis } from 'domains/care-plans';
import { FullClient } from 'domains/client';
import { Contact } from 'domains/contact/types';
import { ContractedBusiness } from 'domains/insurance';
import { AnyNote } from 'domains/notes/types';
import { Therapist } from 'domains/therapists';

/** note(juan): should be updated anytime the Superbill type changes, in order to prevent loading old data with a different contract */
const SUPERBILL_STORAGE_VERSION = 'v1.0';

export type SuperbillSummary = {
  client: FullClient;
  clientDiagnoses: Diagnosis[];
  medicalDiagnoses: MedicalDiagnosis[];
  therapist: Therapist;
  claim?: Claim;
  note: AnyNote;
  contact: Contact;
  contractedBusiness: ContractedBusiness;
  payment?: Payment;
};

export type SuperbillStorage = {
  version: typeof SUPERBILL_STORAGE_VERSION;
  data: SuperbillSummary;
};

const SUPERBILL_PDF_LS_KEY = 'superbill';

export const getSuperbillPDFStoragePair = ({
  clientDiagnoses,
  medicalDiagnoses,
  claim,
  therapist,
  note,
  client,
  contact,
  contractedBusiness,
  payment,
}: SuperbillSummary): [string, string] => {
  const value = JSON.stringify({
    version: 'v1.0',
    data: {
      clientDiagnoses,
      medicalDiagnoses,
      claim,
      therapist,
      note,
      client,
      contact,
      contractedBusiness,
      payment,
    },
  } as SuperbillStorage);

  return [SUPERBILL_PDF_LS_KEY, value];
};

export const saveSuperbillToStorage = (data: SuperbillSummary) => {
  localStorage.setItem(...getSuperbillPDFStoragePair(data));
};

export const loadSuperbillFromStorage = (): SuperbillSummary | null => {
  const storageString = localStorage.getItem(SUPERBILL_PDF_LS_KEY);

  if (!storageString) {
    return null;
  }
  const storage: SuperbillStorage = JSON.parse(storageString);

  if (storage.version !== SUPERBILL_STORAGE_VERSION) {
    return null;
  }

  return storage.data;
};
